// extracted by mini-css-extract-plugin
module.exports = {"refLink":"referral_refLink__3e_kO","refLinkBtn":"referral_refLinkBtn__5Ne0p"};